export interface CategoryItem {
  title: string;
  link: string;
  img: string;
  isInHeader?: boolean;
}

const listCategory: CategoryItem[] = [
  {
    title: 'GWF Cards',
    link: 'carte',
    img: 'img/utilities/cartebanner.jpg',
    isInHeader: true,
  },
  {
    title: 'Lottatori',
    link: 'wrestlers',
    img: 'img/utilities/lottatori_banner.webp',
    isInHeader: true,
  },
  {
    title: 'PPV',
    link: 'ppv',
    img: 'img/utilities/ppv_banner.webp',
    isInHeader: true,
  },
  {
    title: 'Statistiche',
    link: 'stats',
    img: 'img/utilities/stats_banner.png',
    isInHeader: true,
  },
  {
    title: "Albo d'oro",
    link: 'belts',
    img: 'img/utilities/albodoro_banner.jpg',
    isInHeader: true,
  },
  {
    title: 'Arene',
    link: 'arenas',
    img: 'img/utilities/arena_banner.webp',
    isInHeader: true,
  },
];

export default listCategory;
